import {
	connect
} from 'react-redux'
import MaintenanceOrdersComponent from '../components/MaintenanceOrdersComponent.jsx';
import { forwardToCloseMaintenanceOrderModal } from '../actions';

const mapStateToProps = (state) => ({
	showAddOrderModal: state.getIn(['maintenanceOrderReducer', 'showAddOrderModal']),
	showEditOrderModal: state.getIn(['maintenanceOrderReducer', 'showEditOrderModal']),
	showEditOrderDetailModal: state.getIn(['maintenanceOrderReducer', 'showEditOrderDetailModal']),
	showViewOrderModal: state.getIn(['maintenanceOrderReducer', 'showViewOrderModal']),
})

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => {
		dispatch(forwardToCloseMaintenanceOrderModal());
	},
})

const MaintenanceOrdersContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(MaintenanceOrdersComponent)

export default MaintenanceOrdersContainer;


// WEBPACK FOOTER //
// ./src/containers/MaintenanceOrdersContainer.jsx